import { fromJS, OrderedMap } from "immutable";

import Course from "seneca-common/features/course/state/models/state/courses/course/Course";

import queryActionTypes from "../../../action-types";
import { CoursesState } from "../../../models/CoursesQuery";

export function makeReducer(actionTypes: typeof queryActionTypes) {
  function coursesReducer(state: CoursesState, action: any) {
    if (action.type === actionTypes.RECEIVE_QUERY_RESULTS) {
      const { results } = action.payload;
      const emptyState = OrderedMap();
      return emptyState.withMutations(emptyState => {
        const courses =
          (results &&
            results.hits &&
            results.hits.map((hit: any) => hit._source)) ||
          [];
        return courses.forEach((courseDetails: any) => {
          return emptyState.set(
            courseDetails.id,
            new Course(fromJS(courseDetails) as any)
          );
        });
      });
    }

    return state;
  }

  return coursesReducer;
}

export default makeReducer(queryActionTypes);
